module.exports = __webpack_public_path__ + "img/dashboard1.552009f8.png";